// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { telcoinTestnet as _telcoinTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the telcoinTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 2017
 * Chain Name: Telcoin Adiri Testnet
 * Default Block Explorer: https://telscan.io
 * Default RPC URL: https://rpc.telcoin.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { telcoinTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: telcoinTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const telcoinTestnet = createCommon({
	..._telcoinTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
